import { render, staticRenderFns } from "./MsgDetail.vue?vue&type=template&id=a9b18294&scoped=true&"
import script from "./MsgDetail.vue?vue&type=script&lang=js&"
export * from "./MsgDetail.vue?vue&type=script&lang=js&"
import style0 from "./MsgDetail.vue?vue&type=style&index=0&id=a9b18294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b18294",
  null
  
)

export default component.exports